function Page({ sidebar, children }) {
  return (
    <div className="flex w-full h-screen bg-background">
      {sidebar}
      <div className="flex-1 h-full overflow-auto relative">
        {children}
      </div>
    </div>
  );
}

export default Page;